<template>
  <b-row>
    <b-col cols="12">
      <b-card>
        <div class="cs-header-table">
          <div class="custom-search d-flex justify-content-end">
            <b-form-group>
              <div class="d-flex align-items-center">
                <label style="width: 100px" class="mr-1">Tìm kiếm</label>
                <b-form-input
                  v-model="searchTerm"
                  placeholder="Tìm kiếm"
                  type="text"
                  class="d-inline-block"
                />
              </div>
            </b-form-group>
          </div>
          <b-form-group>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              @click="handle()"
            >
              Tạo mới
            </b-button>
          </b-form-group>
        </div>

        <!-- table -->
        <vue-good-table
          :columns="columns"
          :rows="listData"
          :search-options="{
            enabled: true,
            externalQuery: searchTerm,
          }"
          :pagination-options="{
            enabled: true,
            perPage: pageLength,
          }"
          styleClass="vgt-table"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field === 'index'" class="text-nowrap">
              <span class="text-nowrap">
                {{ props.index + (currentPage - 1) * pageLength + 1 }}
              </span>
            </span>
            <!-- Column: Name -->
            <span v-if="props.column.field === 'name'" class="text-nowrap">
              <span class="text-nowrap">{{ props.row.name }}</span>
            </span>
            <!-- Column: Action -->
            <span v-else-if="props.column.field === 'action'">
              <span>
                <b-dropdown
                  variant="link"
                  toggle-class="text-decoration-none btn-padding-table"
                  no-caret
                >
                  <template v-slot:button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="text-body align-middle mr-25"
                    />
                  </template>
                  <b-dropdown-item @click="handle(props.row)">
                    <feather-icon icon="Edit2Icon" class="mr-50" />
                    <span>Sửa</span>
                  </b-dropdown-item>
                  <b-dropdown-item @click="handleDelete(props.row.id)">
                    <feather-icon icon="TrashIcon" class="mr-50" />
                    <span>Xóa</span>
                  </b-dropdown-item>
                </b-dropdown>
              </span>
            </span>

            <!-- Column: Common -->
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>

          <!-- pagination -->
          <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
              <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap"> Hiển thị 1 đến </span>
                <b-form-select
                  v-model="pageLength"
                  :options="pageOptions"
                  class="mx-1"
                  @input="
                    (value) => props.perPageChanged({ currentPerPage: value })
                  "
                />
                <span class="text-nowrap"> của {{ props.total }} dòng </span>
              </div>
              <div>
                <b-pagination
                  v-model="currentPage"
                  :total-rows="props.total"
                  :per-page="pageLength"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
                  @input="(value) => props.pageChanged({ currentPage: value })"
                >
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </div>
            </div>
          </template>
        </vue-good-table>

        <!-- modal Create Edit-->
        <b-modal
          ref="my-modal"
          v-model="showModal"
          no-close-on-backdrop
          centered
          title="Thông tin"
          ok-title="Lưu"
          cancel-title="Đóng"
          cancel-variant="outline-secondary"
          @ok="handleOk"
        >
          <validation-observer ref="simpleRules">
            <form ref="form" @submit.stop.prevent="handleSubmit">
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Mã"
                  rules="required"
                >
                  <label style="font-size: 13px"
                    >Mã <span style="color: red">*</span></label
                  >
                  <b-form-input
                    v-model="model.code"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Mã"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Mã quốc gia"
                  rules="required"
                >
                  <label style="font-size: 13px"
                    >Mã quốc gia <span style="color: red">*</span></label
                  >
                  <b-form-input
                    v-model="model.qgCode"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Mã"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Tên"
                  rules="required"
                >
                  <label style="font-size: 13px"
                    >Tên <span style="color: red">*</span></label
                  >
                  <b-form-input
                    v-model="model.name"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Tên"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Hình thức hưởng"
                  rules="required"
                >
                  <label style="font-size: 13px"
                    >Hình thức hưởng <span style="color: red">*</span></label
                  >
                  <b-form-input
                    v-model="model.hinhThucHuong"
                    :state="errors.length > 0 ? false : null"
                    placeholder=""
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Loại hình thức hưởng"
                  rules="required"
                >
                  <label style="font-size: 13px"
                    >Loại hình thức hưởng
                    <span style="color: red">*</span></label
                  >
                  <b-form-input
                    v-model="model.loaiHinhThucHuong"
                    :state="errors.length > 0 ? false : null"
                    placeholder=""
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="description"
                  rules=""
                >
                  <label style="font-size: 13px">Mô tả</label>
                  <b-form-input
                    v-model="model.description"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Mô tả"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </form>
          </validation-observer>
        </b-modal>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { ref, watch } from "@vue/composition-api";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import { required, email, confirmed, password } from "@validations";
import LayoutData from "@/layouts/LayoutData";
import {
  BRow,
  BCol,
  BButton,
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BCard,
  BCardHeader,
  BCardBody,
  BCollapse,
  BModal,
  VBModal,
} from "bootstrap-vue";

import Ripple from "vue-ripple-directive";
import BCardCode from "@core/components/b-card-code/BCardCode.vue";
import vi from "vee-validate/dist/locale/vi.json";

import { VueGoodTable } from "vue-good-table";
import store from "@/store/index";
import {
  LoaiPhuCapGetAll as GetAll,
  LoaiPhuCapCreate as Create,
  LoaiPhuCapUpdate as Update,
  LoaiPhuCapDelete as Delete,
} from "@/services/api/Common/Category/LoaiPhuCapService";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

localize("vi", vi);
export default {
  components: {
    BRow,
    BCol,
    BCardCode,
    VueGoodTable,
    BCard,
    BCardHeader,
    BCardBody,
    BCollapse,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BButton,
    BModal,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
    "b-modal": VBModal,
  },
  data() {
    return {
      currentPage: 1,
      pageLength: 10,
      pageOptions: [5, 10, 25, 50, 100],
      dir: false,
      columns: [
        {
          label: "STT",
          field: "index",
          width: "100px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "Mã",
          field: "code",
        },
        {
          label: "Tên",
          field: "name",
        },
        {
          label: "Hình thức hưởng",
          field: "hinhThucHuong",
        },
        {
          label: "#",
          field: "action",
          width: "100px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: false,
        },
      ],
      listData: [],
      searchTerm: "",
      showModal: false,
      model: [],
    };
  },
  computed: {
    totalRows() {
      return this.listData.length;
    },
  },
  created() {
    this.getAll();
  },
  setup(props) {
    const headerData = ref(LayoutData.header.data);
    headerData.value.title = "Quản lý loại phụ cấp";
    document.title = `${headerData.value.title} | ${LayoutData.appInfo.data.appName}`;
    return {
      headerData,
    };
  },
  methods: {
    getAll() {
      GetAll().then(async (res) => {
        const { data } = await res;

        this.listData = data;
      });
    },
    handle(value) {
      this.showModal = true;
      if (value == undefined) this.model = [];
      else {
        this.model = JSON.parse(JSON.stringify(value));
        // console.log(this.model);
      }
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // console.log("fdf", bvModalEvt);
      // Trigger submit handler
      this.handleSubmit();
    },
    handleSubmit() {
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          // console.log("id", this.model.id);
          if (this.model.id != 0 && this.model.id != null) {
            // Update
            Update(this.model).then((res) => {
              if (res.isError) {
                // console.log("ưewr");
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "Error",
                    icon: "AlertTriangleIcon",
                    variant: "error",
                    text: res.message,
                  },
                });
              } else {
                // console.log("ưewssssssssssssssssssssssssr");
                this.getAll();
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "Thành công",
                    icon: "CheckIcon",
                    variant: "success",
                    text: res.message,
                  },
                });
              }
            });
          } else {
            // Create
            Create(this.model).then((res) => {
              if (res.isError) {
                // console.log("ưewr");
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "Error",
                    icon: "AlertTriangleIcon",
                    variant: "error",
                    text: res.message,
                  },
                });
              } else {
                // console.log("ưewssssssssssssssssssssssssr");
                this.getAll();
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "Thành công",
                    icon: "CheckIcon",
                    variant: "success",
                    text: res.message,
                  },
                });
              }
            });
          }
          this.$nextTick(() => {
            this.$refs["my-modal"].toggle("#toggle-btn");
          });
        }
      });
      // console.log("ưewr", this.name);
    },

    handleDelete(id) {
      this.$bvModal
        .msgBoxConfirm("Dữ liệu đã xóa sẽ không được khôi phục lại!", {
          title: "Bạn chắc chứ?",
          size: "sm",
          okVariant: "primary",
          okTitle: "Xóa",
          cancelTitle: "Hủy",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            Delete({
              id,
            }).then((res) => {
              if (res.isError) {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "Error",
                    icon: "AlertTriangleIcon",
                    variant: "error",
                    text: res.message,
                  },
                });
              } else {
                this.getAll();
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "Thành công",
                    icon: "CheckIcon",
                    variant: "success",
                    text: res.message,
                  },
                });
              }
            });
          }
        });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
